import { Zero, Logger, Components } from 'Zero';
import $ from 'Vendor/jquery';
const Log = new Logger('Zero/StoreLocator/ZFilters');

export default class ZFilters extends Components {
  get Selectors() {
    return {
      FiltersCounter: '.filters-counter',
      ApplyFiltersBtn: '.apply-filter-btn',
      ClearFiltersBtn: '.clear-filter-btn',
      // ResetFiltersBtn: '.js-filters-reset',
      FilterInput: 'input[name="features"]',
      FiltersLabelsContainer: '.js-mr_sl-filters-labels',
    };
  }

  get react() {
    return {
      calculateFilters: function() {
        var filters = Zero.$state.StoreLocator.Filters;
        let tot = this.element.serializeArray().length;
        this.FiltersCounter.text(tot);
      },
    };
  }

  constructor(element) {
    super(element);

    this.FiltersCounter = this.element.find(this.Selectors.FiltersCounter);
    this.ApplyFiltersBtn = this.element.find(this.Selectors.ApplyFiltersBtn);
    this.ClearFiltersBtn = this.element.find(this.Selectors.ClearFiltersBtn);
    this.FilterInput = this.element.find(this.Selectors.FilterInput);
    // this.ResetFiltersBtn = this.element.find(this.Selectors.ResetFiltersBtn);

    this.ApplyFiltersBtn.on('click.filters', e => {
      e.preventDefault();
      let f = this.applyFilters();
      this.element.addClass('is-filtered');
      // this.CAST("Storelocator:Filter:Applied", f);
    });

    this.ClearFiltersBtn.on('click.filters', () => {
      this.element.removeClass('is-filtered');
      this.resetFilters();
      // this.CAST("Storelocator:Filter:Clear", {});
      // this.calculateFilters();
      $('.clear-all-filter-btn').hide();
    });


    this.onFilterSelection();
    this.calculateFilters();
    this.onLabelCreation();
    this.filtersShortcut();
    this.clearAll();
  }

  onFilterSelection() {
    var self = this;

    $('.clear-all-filters-btn').hide();

    self.FilterInput.on('change', function() {
      self.onLabelCreation();

      let n = $('input:checked').length;

      if (n > 0) {
        $('.clear-all-filters-btn').show();
      } else {
        $('.clear-all-filters-btn').hide();
      }
    });
  }


  clearAll() {
    const self = this;

    $('.js-filters-reset').on('click', function() {
      self.resetFilters();
      $(this).hide();
    });
  }

  resetFilters() {
    Zero.$state.StoreLocator.Filters = [];
  }

  // fake filters facets
  filtersShortcut() {
    const self = this;
    $('body').delegate('.active-filter', 'click', function() {
      const ref = this.dataset.activeFilter;
      this.remove();
      $(`#${ref}`).prop('checked', false);
      self.applyFilters();
      self.onLabelCreation();
    });
  }

  onLabelCreation() {
    let filters = document.querySelectorAll('.mm_sl-filter-input:checked');

    if (filters.length > 0) {

      $('#filter-counter').empty();
      $('#filter-counter').append(`<span>(${filters.length})</span>`);
    } else {

      $('#filter-counter').empty();
      $('#filter-counter').append(`<span>(0)</span>`);
    }
  }

  onFiltersLabelsCreation() {
    const c = this.Selectors.FiltersLabelsContainer;
    let filters = Zero.$state.StoreLocator.Filters;
    $(c).empty();
    // change type depending on the number of filters selected..

    const notEmptyFilters = Object.keys(filters).length !== 0;

    if (notEmptyFilters && filters.features) {
      switch (filters.features.constructor) {
        case String:
          if (
            filters.features != '' &&
            filters.features != 'PERSONA' &&
            filters.features != 'MARINA_RINALDI'
          ) {
            const label = $(`#${filters.features}`)
              .next()
              .html();

            $(c).append(
              `<button class="active-filter" data-active-filter=${
                filters.features
              }>
                <span class="">${label}</span>
                <i class="icon-close"></i>
               </button>`
            );
          }
          break;
        case Array:
          for (let item of filters.features) {
            if (item != '' && item != 'PERSONA' && item != 'MARINA_RINALDI') {
              const label = $(`#${item}`)
                .next()
                .html();

              $(c).append(
                `<button class="active-filter" data-active-filter=${item}>
                  <span class="">${label}</span>
                  <i class="icon-close"></i>
                </button>`
              );
            }
          }
          break;
      }
    }
  }

  applyFilters() {
    const filterArr = this.element.serializeArray();
    let resultArr = {};

    for (let object of filterArr) {
      let name = object.name;
      let value = object.value;

      if (value != '') {
        if (resultArr[name]) {
          if (!$.isArray(resultArr[name])) {
            resultArr[name] = [resultArr[name]];
          }
          resultArr[name].push(value);
        } else {
          resultArr[name] = value;
        }
      }
    }
    this.CAST('Storelocator:Filters:Applied', {});

    Zero.$state.StoreLocator.Filters = resultArr;

    this.onFiltersLabelsCreation();
    return resultArr;
  }
}

export { ZFilters };
